<div class="history-header" [class.expanded]="this.active">
  <div class="history-header-content">
    <cc-history-date [date]="date"></cc-history-date>
    <div class="history-header-content-title">{{getTranslateValue() | translate }}</div>
    <div class="history-header-content-data" *ngIf="label || msisdn">
            <span class="history-header-content-data-row">
                <span class="history-header-content-data-row-label"
                      title="{{label}}">{{label}}
                </span>
                <span class="history-header-content-data-row-value phone-number-row" title="{{msisdn}}">
                  <span>{{ getPhoneNumberLabel(event) }}</span>
                  <div>
                    <span *ngIf="getIsoCountry(msisdn)"
                          class="flag-icon flag-icon-{{getIsoCountry(msisdn)}} m-r-sm shadow-up"></span>
                    <span>{{msisdn | phoneNumber}}</span>
                  </div>
                </span>
            </span>
    </div>
  </div>
  <i *ngIf="!this.active && showIcon" class="history-header-arrow-down material-icons">keyboard_arrow_down</i>
  <i *ngIf="this.active && showIcon" class="history-header-arrow-up material-icons">keyboard_arrow_up</i>
</div>
